import { z } from 'zod';
import {
  allowedRoleIdSchema,
  portRangeSchema,
  protocolSchema,
  ruleDescriptionSchema,
} from '#schemas/firewall-rule/index.ts';
import { cidrRequiredSchema } from '#schemas/general/cidr.ts';
import { tagNameSchema } from '#schemas/tag/name.ts';

export const cidrFirewallRuleFormSchema = z.object({
  description: ruleDescriptionSchema,
  allowedRoleID: allowedRoleIdSchema,
  protocol: protocolSchema,
  tags: z.array(tagNameSchema),
  localCIDR: cidrRequiredSchema.or(
    z
      .string()
      .refine(
        (x) => x.trim() === '' || x.toLowerCase() === 'any',
        'Please provide an IP range in CIDR notation (e.g. 192.168.2.0/30) or leave blank for all IP addresses.'
      )
      .transform(() => 'Any')
  ),
  portRange: portRangeSchema,
});

export type CIDRFirewallRuleFormData = z.infer<typeof cidrFirewallRuleFormSchema>;
